/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: ({isDisabled}) => ({
        container: {
            alignItems: 'flex-start',
            color: 'stokkeCore.black',
            _invalid: {
                color: 'stokkeFunctional.alertRed'
            }
        },
        control: {
            bg: 'stokkeCore.white',
            border: '1px',
            borderColor: null,
            borderRadius: 'base',
            color: null,
            _checked: {
                bg: 'stokkeCore.black',
                borderColor: 'stokkeCore.black',
                color: 'stokkeCore.white',
                _hover: {
                    bg: null,
                    borderColor: null
                }
            },
            _indeterminate: {
                bg: 'stokkeCore.black',
                borderColor: 'stokkeCore.black',
                color: 'stokkeCore.white'
            },
            _focus: {
                boxShadow: 'none'
            },
            _invalid: {
                borderColor: null
            },
            _disabled: {
                bg: 'transparent',
                border: 'none'
            }
        },
        icon: isDisabled
            ? {
                  opacity: 1,
                  transform: 'scale(1)'
              }
            : {},
        label: {
            width: 'full'
        }
    }),
    variants: {
        link: {
            label: {
                textDecoration: 'underline',
                textUnderlineOffset: 'var(--chakra-space-linkUnderlineOffset)',
                _disabled: {
                    opacity: null
                }
            }
        },
        focused: {
            control: {
                _focus: {
                    boxShadow: 'outline'
                }
            }
        }
    },
    sizes: {
        sm: {
            control: {
                w: 4,
                h: 4
            },
            icon: {
                boxSize: '10.67px'
            },
            label: {
                marginStart: 2,
                ...textStyles['Regular Small']
            }
        },
        md: ({isDisabled}) => ({
            control: {
                w: 6,
                h: 6
            },
            icon: {
                boxSize: isDisabled ? 6 : 4
            },
            label: {
                marginStart: 3,
                ...textStyles['Regular Medium']
            }
        }),
        lg: ({isDisabled}) => ({
            control: {
                w: 6,
                h: 6
            },
            icon: {
                boxSize: isDisabled ? 6 : 4
            },
            label: {
                marginStart: 3,
                ...textStyles['Regular 2XLarge']
            }
        })
    },
    defaultProps: {
        colorScheme: null
    }
}
